"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_pfeil_nord = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_pfeil_nord = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACqSURBVFhH7Y7BDcIwEAStvHhSAiVQGiWkE56UwJMSKIESKCHZFT7JsnwYhZwtJTfSyPYj2QnOFrjAw+faniuc4B02j5BxsWlEPt40QhsXTSPS8Td8Fe5mEfn4GT7im+OneJpElMZJGkBMIrRxkgeQVSNGqI2TUgDJI25wEUf4hKVxogUQidC+/RlGaD/4FkAY8dd4jVpAlSGe3fAAD/AAD/AAD+gesHdCmAGphFSSk+W11AAAAABJRU5ErkJggg==",
    iconSize: [32, 32],
});
